import React from 'react';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';

import {
  ProgressOverlay,
  ProgressCard,
  ProgressTitle,
  ProgressStatus,
} from './routeOptimizationStyles';

function OptimizationProgress() {
  return (
    <ProgressOverlay>
      <ProgressCard>
        <ComponentCircleLoader />
        <ProgressTitle>Optimizing Routes</ProgressTitle>
        <ProgressStatus>
          Please wait while we optimize the routes for your team...
        </ProgressStatus>
      </ProgressCard>
    </ProgressOverlay>
  );
}

export default OptimizationProgress;

